import {Box, Button, CircularProgress, Stack, Typography} from '@mui/material';
import HospitalizationImg from 'presentation/assets/images/hospitalization.svg';
import {AlertModal, StyledCard} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {useMediaQueries} from 'presentation/pages/private/hooks/useMediaQueries';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {useConcierge} from 'presentation/pages/private/my-hospitalization/hooks/useConcierge';
import {SectionContainer} from '../SectionContainer';

const {title, active, description, access, altImage} =
	translations['pt-br'].privateFlow.home.concierge;
const {serverError2, serverErrorTitle2, tryAgain, notice} = translations['pt-br'].commons;

export function Concierge() {
	const {isTablet} = useMediaQueries();

	const {isError, isFetching, handleOpenUrl, handleCloseErrorModal} = useConcierge();

	return (
		<Fragment>
			<SectionContainer
				showTitle
				title={title}
				titleMarginTop={0}
				titleMarginBottom={isTablet ? 2 : 1}>
				<StyledCard.Container>
					<Stack direction="row" gap={1} alignItems="center">
						<Stack flexGrow={1}>
							<Typography
								variant="subtitle1"
								lineHeight={1.2}
								color="primary"
								fontWeight={600}>
								{active}
							</Typography>
							<Typography variant="body2" color="text.primary" mt={0.5}>
								{description}
							</Typography>
							<Button
								data-tag-id={AppointmentBookingEnum.CLICK_ACESSAR_CONCIERGE}
								variant="contained"
								color="primary"
								sx={{mt: 1.5, alignSelf: 'flex-start'}}
								size="medium"
								onClick={handleOpenUrl}
								disabled={isFetching}
								endIcon={
									isFetching ? (
										<CircularProgress size={16} color="inherit" />
									) : null
								}>
								{access}
							</Button>
						</Stack>
						<Box flexShrink={0}>
							<img src={HospitalizationImg} alt={altImage} />
						</Box>
					</Stack>
				</StyledCard.Container>
			</SectionContainer>

			{isError ? (
				<AlertModal
					open={isError}
					onClose={handleCloseErrorModal}
					description={serverError2}
					title={serverErrorTitle2}
					headerTitle={notice}
					variant="info"
					footerContent={
						<Button
							variant="contained"
							size="large"
							fullWidth
							onClick={() => {
								handleCloseErrorModal();
								handleOpenUrl();
							}}>
							{tryAgain}
						</Button>
					}
				/>
			) : null}
		</Fragment>
	);
}
